import { AchBatchFilterModelDto, AchCompanyModelDto } from '@treasury/api/channel';

export enum TaxType {
    State = 2,
    Federal = 3,
}

export enum TaxTemplateSearchType {
    Federal = 1,
    State = 2,
    Both = 3,
}

export interface TaxAmountLine {
    amount: number;
    amountTypeId: number;
    amountTypeName: string;
    amountTypeDescription: string;
}

export interface TaxCode {
    id: number;
    taxCode: string;
    description: string;
}

export interface TaxAmountType {
    id: number;
    name: string;
    description: string;
}

export interface AccountType {
    id: number;
    name: string;
    description: string;
    reportingType?: string;
}

export interface TaxRecipient {
    accountNumber: string;
    accountTypeId: number;
    routingNumber: string;
    name: string;
}

export interface TaxTemplateFilter {
    taxTemplateType: TaxTemplateSearchType;
    status: string;
    achCompanyList: { id: number }[];
    batchName: string;
    amountType: string;
    amountMin: number;
    amountMax: number;
    updatedDateType: string;
    lastUpdatedStart: string;
    lastUpdatedEnd: string;
}

export function createDefaultTaxTemplateFilter(): TaxTemplateFilter {
    return {
        taxTemplateType: TaxTemplateSearchType.Both,
        status: '',
        achCompanyList: [],
        batchName: '',
        amountType: '',
        amountMin: 0,
        amountMax: 0,
        updatedDateType: '',
        lastUpdatedStart: '',
        lastUpdatedEnd: '',
    };
}

export function taxTemplateFilterToDto(filter: TaxTemplateFilter): AchBatchFilterModelDto {
    return {
        taxTemplateType: filter.taxTemplateType,
        status: filter.status,
        achCompanyList: filter.achCompanyList as AchCompanyModelDto[],
        batchName: filter.batchName,
        creditAmountType: filter.amountType,
        creditAmountMin: filter.amountMin,
        creditAmountMax: filter.amountMax,
        updatedDateType: filter.updatedDateType,
        lastUpdatedStart: filter.lastUpdatedStart,
        lastUpdatedEnd: filter.lastUpdatedEnd,
        secCode: '',
        amountType: '',
        amountMin: 0,
        amountMax: 0,
        debitAmountType: '',
        debitAmountMin: 0,
        debitAmountMax: 0,
        debitAmount: 0,
        creditAmount: 0,
        updatedDate: '',
    };
}
